let data = {
    comments: [
        {
            user: 'Gwen',
            id: 1,
            title: "Awesome Burgers",
            text: "The taste of this meal is absolutely incredible! The burgers are a flavor fiesta. Love it!",
            date: '10.12.2023, 10:40:53'
        },
        {
            user: 'Joey',
            id: 2,
            title: "Delicious food",
            text: "Order this meal every time, it\'s delicious, like it so much!",
            date: '02.12.2023, 08:50:00'
        },
        {
            user: 'Thomas',
            id: 3,
            title: "Not bad",
            text: "We ordered chicken burgers with fries. Not bad actually but it would be better if crispy fried chicken has more roasted garlic taste.",
            date: '17.10.2023, 12:33:00'
        },
        {
            user: 'Megan',
            id: 4,
            title: "An average food and delayed deliveries",
            text: "An average food, I\'ve had better. Besides, the delivery guy delivered the burgers 40 minutes late",
            date: '12.08.2023, 14:45:00'
        },
        {
            user: 'Jennifer',
            id: 5,
            title: "Very tasty",
            text: "Very tasty, highly recommend it.",
            date: '10.05.2023, 15:50:00'
        },
    ]
}

export default data;